document.querySelectorAll('.goto-block').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();

    const target = document.querySelector(btn.dataset.scrollTarget);
    if (!target) return;

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: target,
        offsetY: 120,
      },
      ease: 'power2.out',
    });

  });
});

window.addEventListener('load', () => {
  setTimeout(() => {
    const sections = document.querySelectorAll('main.page-content div[id^="block-"]');

    sections.forEach((section) => {
      const sectionId = `#${section.id}`;
      const correspondingBtn = document.querySelector(
        `.goto-block[data-scroll-target="${sectionId}"]`
      );

      if (!correspondingBtn || !section.id) return;

      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        markers: false,
      });
    });

    ScrollTrigger.refresh();
  }, 300);
});